<template>
  <header>
    <div v-if="showNavigation">
      <app-navigation />
    </div>
  </header>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Account } from "@/entities/auth/Account";
import AppNavigation from "@/components/AppNavigation.vue";
import { Role } from "@/entities/auth/Role";

@Component({
  components: {
    AppNavigation
  },
})
export default class AppHeader extends Vue {
  get isLoginPage(): boolean {
    return this.$route.name === "Login";
  }

  get isAuthenticated(): boolean {
    return this.$store.getters["authentication/isAuthenticated"];
  }

  get isAuthLoading(): boolean {
    return this.$store.getters["authentication/isAuthLoading"];
  }

  get isLoggingIn(): boolean {
    return this.$store.getters["authentication/isLoggingIn"];
  }

  get showNavigation(): boolean {
    // Only show navigation when authenticated AND not loading AND not logging in
    return this.isAuthenticated && !this.isAuthLoading && !this.isLoggingIn;
  }
}
</script>

<style lang="scss" scoped>
@import "node_modules/bootstrap/scss/_functions.scss";
@import "node_modules/bootstrap/scss/_variables.scss";
@import "node_modules/bootstrap/scss/_mixins.scss";

.no-outline {
  outline: none;
}

img.logo {
  width: 250px;
  padding: 10px;
}

.user-info {
  margin-right: 0.625rem;

  &__greeting {
    padding: 0;
    margin: 0;
  }

  &__role {
    margin-top: -0.2rem;
    display: block;
    font-size: 0.8rem;
  }

  @include media-breakpoint-down(xs) {
    margin-right: 0;
  }
}

@include media-breakpoint-down(xs) {
  .no-outline,
  .logo {
    display: none;
  }
}
</style>